
<template>
  <client-only>
    <div class="inner-wrap">
      <SmartAgentFieldExpantionMailing :agent-code="agentCode" />
    </div>
  </client-only>
</template>

<script>
import SmartAgentFieldExpantionMailing from '@/components/Candidates/Pages/SmartAgentManager/SmartAgentFieldExpantionMailing';
import { SMART_ALERTS_REMOVE_DATA } from '@/lib/api.js';

export default {
  middleware: 'personalPage',
  layout: 'personal',
  name: 'smartalertsremovePage',
  data() {
    return {
      agentCode: null,
    };
  },
  components: {
    SmartAgentFieldExpantionMailing,
  },

  async fetch(context) {
    const { query } = context.route;

    try {
      const { data } = await context.$axios(`${SMART_ALERTS_REMOVE_DATA}`, {
        params: query,
      });

      if (data.IsRedirect) {
        let redirectUrl = data.RedirectTo ? data.RedirectTo : '/';
        context.redirect(307, redirectUrl);
        return;
      }
      context.store.commit('INIT_REMOVE_DATA', data);
    } catch (e) {
      console.log('error SMART_ALERTS_REMOVE_DATA');
    }
  },

  mounted() {
    window.scrollTo(0, 0);
    const { agentcode } = this.$route.query;
    this.agentCode = agentcode;
  },
};
</script>
